import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { Box, Divider, Typography, useBreakpoint } from "@avenue-8/sidekick-ui";
import { InsightsSectionView } from "@cma/presentation-generation-logic";
import { InsightItem, InsightsSwiperContainer } from "./Insights.styles";
import { PresentationSectionViewProps } from "../PresentationSectionProps";
import { useMemo } from "react";

interface Props extends PresentationSectionViewProps<InsightsSectionView> {}

export const InsightsView = (props: Props) => {
  const {
    sectionView,
    // preferences: p, // TODO: use the preferences to show/hide
  } = props;
  const { id, insights } = sectionView;

  const isMobile = useBreakpoint("mobile");

  const insightsToDisplay = useMemo(() => {
    return insights?.filter((x) => x.mode === "ok") || [];
  }, [insights]);

  const slidesPerView = useMemo(() => {
    if (insightsToDisplay.length === 1) return 1;

    if (isMobile) {
      return 1.3;
    }

    if (insightsToDisplay.length <= 3) {
      return insightsToDisplay.length;
    }

    return 3.3;
  }, [isMobile, insightsToDisplay]);

  if (insightsToDisplay.length === 0) {
    return null;
  }

  return (
    <Box
      id={id}
      py={3}
      px={3}
      textAlign="center"
      maxWidth={"lg"}
      margin="0 auto"
    >
      <Divider sx={{ width: "5rem", margin: "2rem auto 0" }} />
      <Typography variant="h5" mt={2}>
        Market Insights
      </Typography>

      <InsightsSwiperContainer>
        <Swiper
          slidesPerView={slidesPerView}
          modules={[Navigation]}
          grabCursor={true}
          allowTouchMove={true}
          observer={true}
          observeParents={true}
          resizeObserver={true}
          updateOnWindowResize
          mousewheel
          spaceBetween={insightsToDisplay.length > 1 ? 16 : 0}
        >
          {insightsToDisplay.map((insight, index) => (
            <SwiperSlide key={`insight-${index}`}>
              <InsightItem>
                <Typography variant="body1">{insight.content}</Typography>
                <Typography variant="body2">{insight.footer}</Typography>
              </InsightItem>
            </SwiperSlide>
          ))}
        </Swiper>
      </InsightsSwiperContainer>
    </Box>
  );
};
